import { atom } from "jotai";

export const isIndicatorSelectModalOpenAtom = atom(false);
